import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { BRAND } from '../data/siteContent';
import studentBook from '../assets/images/student-book.png';

export default function AboutPage() {
  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <div className="mk-page-hero-grid">
            <div>
              <span className="mk-eyebrow">About</span>
              <h1>A calmer way to prepare for the GED.</h1>
              <p>
                {BRAND.name} pairs a 24/7 AI tutor with lessons, quizzes, and practice exams so you can study at your own pace.
              </p>
              <div className="mk-inline-actions" style={{ marginTop: 20 }}>
                <Link to="/signup" className="mk-btn mk-btn-primary">
                  Enroll
                </Link>
                <Link to="/contact" className="mk-btn mk-btn-secondary">
                  Talk to an advisor
                </Link>
              </div>
            </div>
            <div className="mk-page-photo-card mk-page-photo-tall">
              <img src={studentBook} alt="Student reading while preparing for the GED" />
            </div>
          </div>
        </div>
      </header>
    </MarketingLayout>
  );
}
